import { render, staticRenderFns } from "./LargeFormatPrinting.vue?vue&type=template&id=53e79019&scoped=true&"
import script from "./LargeFormatPrinting.vue?vue&type=script&lang=js&"
export * from "./LargeFormatPrinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e79019",
  null
  
)

export default component.exports